import { db, collections, ROLES } from '../firebase.marketplace';
import { doc, getDoc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';

/**
 * Make kihembowilb@gmail.com a super admin
 * This script can be executed from the browser console
 */
export const makeKihemboAdmin = async () => {
  try {
    console.log('Starting admin privileges update for kihembowilb@gmail.com...');
    
    // Find the user by email
    const email = 'kihembowilb@gmail.com';
    const usersRef = collection(db, collections.USERS);
    const q = query(usersRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      console.error(`No user found with email: ${email}`);
      return { success: false, message: 'User not found' };
    }
    
    const userDoc = querySnapshot.docs[0];
    const userData = userDoc.data();
    const userRef = doc(db, collections.USERS, userDoc.id);
    
    console.log(`Found user: ${userData.email} (${userDoc.id})`);
    
    // Update the user's roles
    const updatedRoles = {
      ...(userData.roles || {}),
      [ROLES.USER]: true,
      [ROLES.ADMIN]: true,
      [ROLES.ARTIST]: true,
      'superadmin': true
    };
    
    await updateDoc(userRef, {
      roles: updatedRoles,
      updatedAt: new Date()
    });
    
    console.log(`Successfully updated ${email} to super admin!`);
    console.log('Updated roles:', updatedRoles);
    
    return { 
      success: true, 
      message: 'Successfully made kihembowilb@gmail.com a super admin',
      user: {
        id: userDoc.id,
        email: userData.email,
        roles: updatedRoles
      }
    };
  } catch (error) {
    console.error('Error making user super admin:', error);
    return { success: false, message: error.message };
  }
};

// Export a function that can be called from a component
export const runKihemboAdminUpdate = () => {
  return makeKihemboAdmin()
    .then(result => {
      if (result.success) {
        alert('Successfully made kihembowilb@gmail.com a super admin!');
      } else {
        alert(`Failed to update admin privileges: ${result.message}`);
      }
      return result;
    })
    .catch(error => {
      alert(`Error: ${error.message}`);
      return { success: false, message: error.message };
    });
};
